<template>
  <header>
    <b-navbar toggleable="md" type="light" variant="light">
      <div class="container">
        <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
        <b-navbar-brand href="#">
          <img src="../assets/img/incluir-da-certo.png"
              alt="Logo da marca Incluir da Certo - Quatro setas, apontando para a mesma direção, que é o centro. Em cada seta uma bolinha. Do lado esquerdo, a cor roxa, embaixo, laranja, no lado direito, a cor verde e acima a cor azul">
        </b-navbar-brand>

        <!-- Menu Principal -->
        <b-collapse is-nav id="nav_collapse">
          <nav class="navmain ml-auto">
            <!-- Right aligned nav items -->
            <b-navbar-nav>
                <b-nav-item href="#quem-somos" onclick="Ancora('quem-somos')" accesskey="1">Quem Somos</b-nav-item>
                <b-nav-item href="#o-que-fazemos" onclick="Ancora('o-que-fazemos')" accesskey="2">O Que Fazemos</b-nav-item>
                <b-nav-item href="#nosso-canal" onclick="Ancora('nosso-canal')" accesskey="3">Nosso Canal no Youtube</b-nav-item>
                <b-nav-item href="#" class="active">Contato</b-nav-item>
            </b-navbar-nav>
          </nav>
        </b-collapse>
        <!-- /Menu Principal -->

      </div>
    </b-navbar>
    <!-- navbar-1.vue -->
  </header>
</template>

<script>
export default {
  name: 'MenuMain',
  data () {
    return {
      msg: 'Incluir da Certo'
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~styles/_bootstrap-variables";
  @import "~styles/_main";
  @import "~styles/_menu";
</style>



// WEBPACK FOOTER //
// src/components/MenuMain.vue